import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import Translate from 'components/Translate';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles({
  termsLink: {
    color: '#3960A3'
  }
});
const AcceptTerms: React.FC = React.memo(() => {
  const classes = useStyles({});

  return (
    <Grid className="chk-creditCardForm__saveCard checkbox_singleStep" item xs={12}>
      <FormControlLabel
        control={<Checkbox id="checkbox-subscription-terms" className="checkbox" value="1" checked />}
        label={
          <>
            <Translate term="Concordo que li, e compreendi os" />
            &nbsp;
            <a id="chk-accept-term" href="https://www.eduzz.com/termos-e-assinatura-e-cancelamento" rel="noopener noreferrer" target="_blank">
              <Translate className={classes.termsLink} term="termos de assinatura e cancelamento" />
            </a>
          </>
        }
      />
    </Grid>
  );
});

export default AcceptTerms;
